import { Box, Grid, Typography } from "@mui/material";
import "../../../utils/styles/Politicas/39001/39001Styles.scss";
import poster1 from "../../../utils/img/Politicas/seguridadvial01.jpg";
import CircleIcon from "@mui/icons-material/FiberManualRecord";
const Politica39001 = () => {
  return (
    <Box
      style={{
        position: "relative",
        marginTop: "-20px",
        zIndex: "1",
        paddingBottom: "20px",
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box className="PoliticasPortada">
        <img src={poster1} alt="" />
      </Box>
      <Grid container style={{ padding: "82px 30px" }} spacing={3}>
        <Grid item xs={12} md={6}>
          <Box className="PoliticasInformacion">
            <Box textAlign="center">
              <Typography className="TittlePolitica39001">
                Política de Seguridad Vial
              </Typography>
            </Box>
            <Box>
              <Box>
                <Typography className="TextPolitica39001">
                  TRANSMDICAS S.R.L. es una empresa de Transporte por Carretera de Materiales Peligrosos y Carga
                  en General, presente en la Industria y Minería; conscientes de nuestra responsabilidad, nos
                  comprometemos a:
                </Typography>
              </Box>
              {/* <Box>
                <Typography className="TextPolitica39001">
                  Siendo conscientes de nuestra responsabilidad, nos
                  comprometemos a cumplir las 05 dimensiones de la seguridad
                  vial:
                </Typography>
              </Box> */}
              <Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Fortalecer la cultura de seguridad vial en todos los niveles de la empresa, mediante la
                    implementación de medidas de prevención y mitigación que reduzcan la probabilidad de
                    accidentes de tráfico y lesiones.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Asegurar la identificación, evaluación y control de los riesgos de seguridad vial asociados a
                    nuestras operaciones.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Promover actitudes y comportamientos seguros en la red vial, mediante acciones de
                    sensibilización, comunicación y formación continua en seguridad vial de todos nuestros
                    conductores.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Garantizar el cumplimiento del programa de mantenimiento preventivo y correctivo, con el
                    objeto de mantener un desempeño óptimo de nuestras unidades.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Evaluar previamente las condiciones climáticas antes de iniciar nuestras operaciones, para
                    identificar riesgos y definir medidas preventivas.
                  </Typography>
                </Box>

                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Asegurar la confiabilidad de nuestras herramientas tecnológicas que nos permitan monitorear,
                    analizar y mejorar el desempeño en seguridad vial, contribuyendo a un tránsito más seguro.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Cumplir con la normativa legal vigente en materia de seguridad vial, así como otros requisitos
                    suscritos por la organización, asegurando su actualización y evaluación periódica.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Activar la herramienta “Para, Piensa y Actúa”, cuando se detecte una condición insegura o en
                    casos de fatiga y somnolencia; ante ello, no se tomará ningún tipo de represalia y solo se
                    reiniciarán las actividades si en la evaluación de riesgos se determina que no afecta la
                    seguridad e integridad física y mental de los colaboradores.
                  </Typography>
                </Box>
                <Box display="flex">
                  <Box>
                    <CircleIcon
                      style={{ fontSize: "small", marginRight: "10px" }}
                    />
                  </Box>
                  <Typography className="TextPolitica39001">
                    Mejorar continuamente el desempeño del Sistema de Gestión de la Seguridad Vial,
                    asegurando su eficacia, pertinencia y alineación con los objetivos de la empresa.
                  </Typography> 
                </Box>
              </Box>
              <Box className="positiconversionandfecha">
                <Typography>V.03</Typography>
                <Typography>09/01/2026</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={5}>
          {/* <div className='imagenContenedor9001' style={{zIndex:2}}>
                        <img src={Image} className="imgNosotrosHome" />
                    </div> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Politica39001;
